import { Injectable } from '@angular/core';
import { forkJoin, map, Observable } from 'rxjs';
import { CampaignService } from 'src/app/_services/campaign.service';
import { CategoryService } from 'src/app/_services/category.service';
import { MmitaAssetService } from 'src/app/_services/mmitaAsset.service';
import { RewardService } from 'src/app/_services/reward.service';
import { StreamService } from 'src/app/_services/streamer.service';
import { VerticalCarouselService } from 'src/app/_services/vertical-carousel.service';

@Injectable({
  providedIn: 'root'
})
export class MapDataSourceService {

  constructor(
    private rewardService: RewardService,
    private assetService: MmitaAssetService,
    private vcService: VerticalCarouselService,
    private campaignService: CampaignService,
    private categoryService: CategoryService,
    private streamService: StreamService
  ) {
  }

  // to remove
  getSource(assetCategoryParam) {
    return new Observable(subscriber => {
      forkJoin({
        allRewards: this.rewardService.getAll({ HosterType: 'MapPlace' }),
        assetCategory: this.categoryService.getAssetCategory(assetCategoryParam),
        vcSourceList: this.vcService.getVerticalCarouselList(),
        portalSource: this.campaignService.getAllPortal({ PageSize: '-1' }),
        streamingEventSource: this.streamService.getStreamingEvents({ PageSize: '-1'}),
        streamerSubTypeAssetSource: this.assetService.getAll({ PageSize: '-1', BusinessType: 'Streamer' }),
        campaignSource: this.campaignService.getAll()
      }).subscribe(res => {
        subscriber.next(res)
        subscriber.complete()
      }, error => {
        subscriber.error()
      })
    })

  }




  getSourceNewVersion() {
    return forkJoin({
      allRewards: this.rewardService.getAll(),
      assetCategory: this.categoryService.getAssetCategory({ IsStageTypeNormal: true }),
      vcSourceList: this.vcService.getVerticalCarouselList(),
      portalSource: this.campaignService.getAllPortal({ PageSize: '-1' }),
      streamingEventSource: this.streamService.getStreamingEvents({ PageSize: '-1'}),
      streamerSubTypeAssetSource: this.assetService.getAll({ PageSize: '-1', BusinessType: 'Streamer' }),
      campaignSource: this.campaignService.getAll(),
      occlusionMeshAssetCategory: this.categoryService.getAssetCategory({ AssetCategoryOption: 'OcclusionMesh' }),
    }).pipe(
      map(res => {
        const dataSource: DataSource = {};

        // 复制所有响应数据
        Object.keys(res).forEach(key => {
          dataSource[key as keyof DataSource] = res[key]?.data;
        });

        // 安全地添加计算属性
        dataSource.mapPlaceRewards = (dataSource.allRewards || []).filter(
          (item: any) => item?.hosterType === 'MapPlace'
        );

        return dataSource;
      })
    );
  }
}

interface DataSource {
  allRewards?: any[];
  assetCategory?: any[];
  vcSourceList?: any[];
  portalSource?: any[];
  streamingEventSource?: any[];
  streamerSubTypeAssetSource?: any[];
  campaignSource?: any[];
  occlusionMeshAssetCategory?: any[];
  mapPlaceRewards?: any[];
}